export enum MediaRepresentationSelectionMode {
    Manual = 'manual',
    Auto = 'auto'
}
